import Component from 'vue-class-component'
import { Vue } from 'vue-property-decorator'

import store from '../common/store/index'
import {
  getHomeUrl,
  getUserGroups,
  getUserName,
  login,
  logout,
  logoutAction,
  saveUserGroups,
  saveUserName
} from '../service/auth'
import { USER_GROUPS, USER_NAME } from '../service/constant'
import { getUrlParams } from '../utils/urlUtils'

@Component
export class AuthMixin extends Vue {
  private restrictMsg = ''
  private showLoading = false

  public async logout() {
    // 登出
    let retData = await logout()
    if (retData.success) {
      logoutAction()
    }
  }

  public tryLogin() {
    let ticket = getUrlParams().ticket
    let username = getUserName()
    let groups = getUserGroups()

    // url包含ticket参数，则尝试登陆操作
    // 如果username或者groups为空也会尝试
    if (!ticket && username && groups.length > 0) return
    const back_url = getHomeUrl()

    this.showLoading = true
    login({ back_url, ticket })
      .then(
        (retData: {
          success: boolean
          restrict: boolean
          detail: string
          username: string
          data: { [USER_NAME]: string; [USER_GROUPS]: { id: string }[] }
        }) => {
          if (retData.success) {
            if (retData.restrict) {
              // 登陆成功，但账号为激活或者过期
              this.restrictMsg = retData.detail

              saveUserGroups([])
              saveUserName(retData.username)
              this.$store.commit('setAuthInfo', {
                [USER_NAME]: retData.username,
                [USER_GROUPS]: []
              })
            } else {
              const groups = (retData.data[USER_GROUPS] || []).map((item) => item.id)
              const name = retData.data[USER_NAME] || ''
              // 无权限组
              if (groups.length == 0) {
                this.restrictMsg = '暂无权限，请联系管理员'
              }

              saveUserGroups(groups)
              saveUserName(name)
              this.$store.commit('setAuthInfo', {
                [USER_NAME]: name,
                [USER_GROUPS]: groups
              })

              // 登陆后跳转到首页
              this.$router.replace({ path: '/' }).catch((_) => {})
            }
          } else {
            logoutAction()
          }
        }
      )
      .finally(() => {
        this.showLoading = false
      })
  }

  public registerLoginInfoSync() {
    window.addEventListener('storage', (event: StorageEvent) => {
      if (event.key == 'vuex') {
        const oldState = JSON.parse(event.oldValue || '{}')
        const newState = JSON.parse(event.newValue || '{}')
        oldState.username = newState.username
        oldState.perm_groups = newState.perm_groups

        store.replaceState(oldState) // 重置整个store之登陆信息
      }
    })
  }
}
